import { Divider, Form, Input } from "antd";
import { useEffect } from "react";
import * as Validation from "../../../../utils/helper/validation";
import * as Apis from "../../../../utils/helper/enum";
import { changeLoader } from "../../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../../../utils/global/globalRequest";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";

const BankDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  let { id } = useParams();

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };

  const handleSubmit = async (values) => {
    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_CANNED_SELLER?.CREATE_CANNED_SELLER;
      let method = "post";
      if (id) {
        url = Apis?.MANAGE_CANNED_SELLER?.EDIT_CANNED_SELLER + "/" + id;
        method = "put";
      }
      let response = await globalRequest(url, method, values, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Canned Seller created successfully";
        if (id) msg = "Canned Seller updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/manage-seller");
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const getVendorDetail = async (id) => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_CANNED_SELLER.GET_CANNED_SELLER_DETAIL + "/" + id,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        if (Array.isArray(data)) {
          data = data[0];
        }

        // Handle both flattened and nested structures
        const sellerData = data?.vendorDetail || data;
        const payoutData = data?.vendorPayoutDetail || sellerData || data;

        form.setFieldValue(
          "benificiory_name",
          payoutData?.beneficiaryName
        );
        form.setFieldValue("iban_number", payoutData?.IBAN);
        form.setFieldValue("swift_code", payoutData?.swiftCode);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    if (id) getVendorDetail(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="min-h-[calc(100vh_-_305px)]">
        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          style={{
            maxWidth: 600,
            width: "100%",
          }}
          initialValues={{
            remember: true,
          }}
          autoComplete="off"
        >
          <Form.Item
            label="Benificiory name"
            name="benificiory_name"
            rules={[
              {
                required: true,
                message: "Please enter your benificiory name.",
              },
              {
                max: 50,
                message: "Maximum 50 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              disabled={true}
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("business_name", value.trimStart());
                handleInputChange("business_name");
              }}
            />
          </Form.Item>
          <Form.Item
            label="IBAN"
            name="iban_number"
            rules={[
              {
                required: true,
                message: "Please enter your iban number.",
              },
              {
                max: 50,
                message: "Maximum 50 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              disabled={true}
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("store_name", value.trimStart());
                handleInputChange("store_name");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Swift Code"
            name="swift_code"
            rules={[
              {
                required: true,
                message: "Please enter your swift code.",
              },
              {
                max: 50,
                message: "Maximum 50 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              disabled={true}
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("swift_code", value.trimStart());
                handleInputChange("swift_code");
              }}
            />
          </Form.Item>
        </Form>
        <Divider />
        <div className="flex justify-end gap-3">
          {/* <Button onClick={() => navigate("/manage-vendor")}>Cancel</Button> */}
          {/* <Button
              type="primary"
              htmlType="submit"
              onClick={() => form.submit()}
            >
              Save
            </Button> */}
        </div>
      </div>
    </>
  );
};
export default BankDetail;
